export default __webpack_public_path__ + "static/media/awmatic.a706fe02.svg";